import { z } from 'zod'

export const TotpFinalizing = z.object({
  req_id: z.number().int(),
  totp: z.string(),
  email_code: z.string()
})

export type TotpFinalizing = z.infer<typeof TotpFinalizing>
